<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card-group deck>
                <b-card>
                    <div class="form-content-wrapper mb-0">
                        <h6 class="form-title mb-2 sameHeight-card-title">SET HARGA JUAL</h6>
                        <div class="content-desc">
                            <p class="mb-2">Upload CSV untuk set harga jual. Format CSV:</p>
                            <p class="mb-2">No Faktur - Harga Jual - Medium - Jual Ke</p>
                            <p class="mb-2 smallText text-muted">
                                Untuk Medium, tulis 1 untuk menyatakan penjualan melalui PGI, 2 untuk menyatakan penjualan melalui SM
                            </p>
                            <p class="mb-2 smallText text-muted">
                                Catatan: Hanya berlaku untuk nomor faktur lelangan yang masih berstatus ORDER. Selain itu, tidak akan diproses.
                            </p>
                            <p class="mb-2 smallText text-muted">
                                <strong>
                                    Pastikan CSV yang anda upload menggunakan delimiter titik koma (;)
                                </strong>
                            </p>
                        </div>
                    </div>
                    <template v-slot:footer>
                        <b-form @submit.prevent="openConfirmSetJual">
                            <b-form-group class="mb-0">
                                <div class="d-flex align-items-center">
                                    <b-form-file
                                        v-model="input.fileUploadHargaJual" name="fileUploadHargaJual"
                                        :state="Boolean(input.fileUploadHargaJual)"
                                        placeholder="Choose a file"
                                        drop-placeholder="Drop file here..."
                                        accept=".csv"
                                        required>
                                    </b-form-file>
                                    <b-button class="ml-2" type="submit" name="uploadHargaBtn" variant="pgiBtn">Kirim</b-button>
                                </div>
                            </b-form-group>
                        </b-form>
                    </template>
                </b-card>
                <b-card>
                    <div class="form-content-wrapper mb-0">
                        <h6 class="form-title mb-2 sameHeight-card-title">SET BATAL KIRIM</h6>
                        <div class="content-desc">
                            <p class="mb-2">Upload CSV untuk set batal kirim. Format CSV:</p>
                            <p class="mb-2">No Faktur</p>
                            <p class="mb-2 smallText text-muted">
                                Catatan: Hanya berlaku untuk nomor faktur lelangan yang masih berstatus ORDER. 
                                Selain itu, tidak akan diproses.
                            </p>
                            <p class="mb-2 smallText text-muted">
                                <strong>
                                    Pastikan CSV yang anda upload menggunakan delimiter titik koma (;)
                                </strong>
                            </p>
                        </div>
                    </div>
                    <template v-slot:footer>
                        <b-form @submit.prevent="openConfirmBatal">
                            <b-form-group class="mb-0">
                                <div class="d-flex align-items-center">
                                    <b-form-file
                                        v-model="input.fileUploadBatalKirim" name="fileUploadBatalKirim"
                                        :state="Boolean(input.fileUploadBatalKirim)"
                                        placeholder="Choose a file"
                                        drop-placeholder="Drop file here..."
                                        accept=".csv"
                                        required>
                                    </b-form-file>
                                    <b-button class="ml-2" type="submit" name="uploadBatalKirimBtn" variant="pgiBtn">Kirim</b-button>
                                </div>
                            </b-form-group>
                        </b-form>
                    </template>
                </b-card>
            </b-card-group>
            <!-- <b-row>
                <b-col md="6" sm="12">
                    <div class="custom-card-dashboard balance-card">
                        <b-form @submit.prevent="openConfirmSetJual">
                            <div class="form-content-wrapper mb-0">
                                <h6 class="form-title mb-2">SET HARGA JUAL</h6>
                                <div class="content-desc">
                                    <p class="mb-2">Upload CSV untuk set harga jual. Format CSV:</p>
                                    <p class="mb-2">No Faktur - Harga Jual - Medium - Jual Ke</p>
                                    <p class="mb-2 smallText text-muted">
                                        Untuk Medium, tulis 1 untuk menyatakan penjualan melalui PGI, 2 untuk menyatakan penjualan melalui SM
                                    </p>
                                    <p class="mb-2 smallText text-muted">
                                        Catatan: Hanya berlaku untuk nomor faktur lelangan yang masih berstatus ORDER. Selain itu, tidak akan diproses.
                                    </p>
                                </div>
                                <b-form-group>
                                    <div class="d-flex align-items-center">
                                        <b-form-file
                                            v-model="input.fileUploadHargaJual" name="fileUploadHargaJual"
                                            :state="Boolean(input.fileUploadHargaJual)"
                                            placeholder="Choose a file"
                                            drop-placeholder="Drop file here..."
                                            accept=".csv"
                                            required>
                                        </b-form-file>
                                        <b-button class="ml-2" type="submit" name="uploadHargaBtn" variant="pgiBtn">Kirim</b-button>
                                    </div>
                                </b-form-group>
                            </div>
                        </b-form>
                    </div>
                </b-col>
                <b-col md="6" sm="12">
                    <div class="custom-card-dashboard balance-card">
                        <b-form @submit.prevent="openConfirmBatal">
                            <div class="form-content-wrapper mb-0">
                                <h6 class="form-title mb-2">SET BATAL KIRIM</h6>
                                <div class="content-desc">
                                    <p class="mb-2">Upload CSV untuk set batal kirim. Format CSV:</p>
                                    <p class="mb-2">No Faktur</p>
                                    <p class="mb-2 smallText text-muted">
                                        Catatan: Hanya berlaku untuk nomor faktur lelangan yang masih berstatus ORDER. 
                                        Selain itu, tidak akan diproses.
                                    </p>
                                </div>
                                <b-form-group>
                                    <div class="d-flex align-items-center">
                                        <b-form-file
                                            v-model="input.fileUploadBatalKirim" name="fileUploadBatalKirim"
                                            :state="Boolean(input.fileUploadBatalKirim)"
                                            placeholder="Choose a file"
                                            drop-placeholder="Drop file here..."
                                            accept=".csv"
                                            required>
                                        </b-form-file>
                                        <b-button class="ml-2" type="submit" name="uploadBatalKirimBtn" variant="pgiBtn">Kirim</b-button>
                                    </div>
                                </b-form-group>
                            </div>
                        </b-form>
                    </div>
                </b-col>
            </b-row> -->
        </div>
        <ModalConfirm id="modal-confirm-setJual" title="Confirm Upload Set Harga Jual Lelang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengupload harga penjualan (CSV) ini?" @submit="onSubmitJual" />
        <ModalConfirm id="modal-confirm-setBatal" title="Confirm Upload Batal Kirim Lelang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengupload (CSV) Batal Kirim ini?" @submit="onSubmitBatal" />
    </div>
</template>

<script>
export default {
    name: 'bulk-set-jual-batal',
    data() {
        return {
            initStatus: 1,
            isSubmitting: false,
            input:{
                fileUploadHargaJual: null,
                fileUploadBatalKirim: null,
            },
        }
    }, 
    methods: {

        openConfirmSetJual(){
            this.$bvModal.show("modal-confirm-setJual")
        },

        onSubmitJual() {
            let payload = new FormData()

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("csv", this.input.fileUploadHargaJual)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("lelang/harga_jual/excel", payload).then(response => {
                this.$helper.toastSucc(this, response.data.name)
                this.$bvModal.hide("modal-confirm-setJual")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openConfirmBatal(){
            this.$bvModal.show("modal-confirm-setBatal")
        },

        onSubmitBatal() {
            let payload = new FormData()

            //----------------- Append Data Kas Mutasi -----------------

            payload.append("csv", this.input.fileUploadBatalKirim)

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("lelang/batal_kirim", payload).then(response => {
                this.$helper.toastSucc(this, response.data.name)
                this.$bvModal.hide("modal-confirm-setBatal")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
    },
}
</script>
